<template>
  <button class="circle-button" type="button" @click="toggle">
    <dpc-icon
      class="circle-button__icon"
      :icon="isStored ? 'bookmarks-saved' : 'bookmarks'"
      :label-path="isStored ? 'removeBookmark' : 'setBookmark'"
    ></dpc-icon>
  </button>
</template>

<script setup>
import { computed, toRefs } from 'vue';
import { useItemsStore, ITEM_TYPES } from '@stores/items';

const props = defineProps({
  eventId: String,
  subscriptionId: String,
});

const store = useItemsStore();
const { eventId, subscriptionId } = toRefs(props);

const type = computed(() =>
  subscriptionId.value ? ITEM_TYPES.subscription : ITEM_TYPES.event
);
const item = computed(() =>
  subscriptionId.value ? subscriptionId.value : eventId.value
);

const isStored = computed(() => {
  return store.includes(type.value, item.value);
});

const toggle = () => {
  store.toggle(type.value, item.value);
};
</script>
